/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { ICartIconViewProps } from '@msdyn365-commerce-modules/cart/src/modules/cart-icon/./cart-icon';
import { IFlyoutCartLineItemViewProps } from '@msdyn365-commerce-modules/cart/src/modules/cart-icon/./components/flyout-cart-line-items';

import { ICartIconData } from '@msdyn365-commerce-modules/cart/src/modules/cart-icon/./cart-icon.data';
import { ICartIconProps } from '../definition-extensions/cart-icon.ext.props.autogenerated';

interface ICartIcon {
    props: {
        cartLabel: string,
        children: string,
        title: string
    };
}

const _renderCartlines = (cartLines: IFlyoutCartLineItemViewProps[] | undefined, props: ICartIconViewProps): JSX.Element[] | null => {
    if (!cartLines) {
        props.context.telemetry.error('Cartlines content is empty, module wont render');
        return null;
    }
    return cartLines.map((cartLine, index) => {
        return (
            <Node {...props.miniCartItemWrapper} key={index}>
                {cartLine.cartline}
                {cartLine.storeLocation}
                {cartLine.remove}
            </Node>
        );
    });
};

const CartIconView: React.FC<ICartIconViewProps & ICartIconProps<ICartIconData>> = (props: ICartIconViewProps & ICartIconProps<ICartIconData>) => {

    try {
        props.config.cartLabel && ((props.cartIcon as ICartIcon).props.cartLabel = props.config.cartLabel.text + (props.cartIcon as ICartIcon).props.cartLabel.substring((props.cartIcon as ICartIcon).props.cartLabel.lastIndexOf(',')));
        props.config.flyoutTitle && ((props.flyoutTitle as ICartIcon).props.children = props.config.flyoutTitle.text);
        props.config.goToCartButtonTitle && ((props.goToCartButton as ICartIcon).props.children = (props.goToCartButton as ICartIcon).props.title = props.config.goToCartButtonTitle.text + (props.goToCartButton as ICartIcon).props.children.substring((props.goToCartButton as ICartIcon).props.children.lastIndexOf(' ')));
    } catch(err) {
        // console.error(err);
    }

    return (
        <Node {...props.miniCartWrapper} {...props.renderModuleAttributes(props)}>
            {props.cartIcon}
            {props.FlyoutContainer ? (
                <Node {...props.FlyoutContainer}>
                    {props.flyoutTitle}
                    <Node {...props.CartlinesWrapper}>
                        {_renderCartlines(props.cartlines, props)}
                    </Node>
                    {props.totalPrice}
                    {props.checkoutAsSignInUserButton}
                    {props.checkoutAsGuestButton}
                    {props.goToCartButton}
                </Node>
            ) : false}
        </Node>
    );
};

export default CartIconView;
